import { fromUnixTime } from 'date-fns';

export function getCtaFeatureStartedAt(cta) {
  return cta?.publishedAt ?? null;
}

export function getCtaFeatureEndedAt(cta, fallbackDate = new Date()) {
  if (cta?.active !== false) return null;

  return cta?.lastActiveChange ? fromUnixTime(cta.lastActiveChange) : fallbackDate;
}
